import { obterPerfisAsync } from "../../services/perfilService";

const atualizarPerfis = async ({ commit }) => {
    const perfis = await obterPerfisAsync();
    commit('atualizarPerfis', perfis);
}

const atualizarPerfil = ({ commit }, perfil) => {
    commit('atualizarPerfil', perfil);
}

export default {
    atualizarPerfis,
    atualizarPerfil
}